import React from 'react'

import DefaultContactInfo from './Default'
import { enhance } from './enhance'
import SpendContactInfo from './Spend'

type Props = {
  flow: string
}

export const ContactInfo: React.SFC<Props> = ({ flow }) => {
  return flow.toLowerCase() === 'spend' ? <SpendContactInfo /> : <DefaultContactInfo />
}

export default enhance(ContactInfo)
